import React, {
  useState,
  useEffect,
  useContext
} from 'react';

import PaymentMethodComponent from './PaymentMethodComponent'
import SubscriptionComponent from './SubscriptionComponent'

import { Elements } from '@stripe/react-stripe-js';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import BlueHero from '../../../assets/images/sprites/blueHero.jpg';

import styled from 'styled-components';
import { ThemeProps } from '../../genericComponents/globalStyles';
import CreditCardCheckoutForm from './CreditCardCheckoutForm';



export default function CheckoutComponent({
  stripePromise,
  paypalClientID,
  userEmail,
  selectedMembership,
  cancelClick,
  membershipLoading,
  stripeSubscription
}){
  return (
    <>
      <HeaderContainer>
        <Subtitle>Checkout</Subtitle>
        <Title>
          Confirm your GABA<br />
          membership and checkout
        </Title>
      </HeaderContainer>
      <ContentContainer>
        <ContainerLimited>
          <PaymentCardContainer>
            {!membershipLoading &&
              selectedMembership.payment_interval>0?
                <Elements stripe={stripePromise} >
                  <FormContainer>
                  <CreditCardCheckoutForm
                    membership={selectedMembership}
                    setShowCheckout={cancelClick}
                    showCheckout={true}
                    cancelClick={cancelClick}
                    stripeSubscription={stripeSubscription}
                  />
                  </FormContainer>
                </Elements>
              :
              <Elements stripe={stripePromise} >
                <PayPalScriptProvider options={{
                  'client-id': paypalClientID,
                  currency: "USD"
                }}>
                  <PaymentMethodComponent
                    cancelPaymentClickHandler={cancelClick}
                    selectedMembership={selectedMembership}
                    userEmail={userEmail}
                    stripeSubscription={stripeSubscription}
                  />
                </PayPalScriptProvider>
              </Elements>
            }
          </PaymentCardContainer>
          <CardContainer>
            {!membershipLoading && (<SubscriptionComponent membership={selectedMembership} />)}
          </CardContainer>
        </ContainerLimited>
      </ContentContainer>
    </>
  )
}

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-image:url(${BlueHero});
  color:  ${props => props.theme.color.white};
  padding:50px 150px;
  @media (max-width: 720px) {
    padding:50px 40px;
  }

`;
const Title = styled.div`
  font-size: 40px;
  font-family: HelveticaNeue-Bold;
  font-weight: bold;
  letter-spacing: -0.5px;
  line-height: 48px;
  max-width: 500px;  
  @media (max-width: 720px) {
    font-size: 24px;
    line-height: 24px;
  }
`;
const Subtitle = styled.div`
  width: 160px;
  height: 24px;
  font-size: 16px;
  font-family: HelveticaNeue-Medium;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 24px;
`;
const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  color:  ${props => props.theme.color.darkBlue};
  margin-bottom: 30px;
  .modal-video-body {
    margin-top: -300px;
  }
`;
const ContainerLimited = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 720px) {
    flex-direction: column;
  }
`;
const CardContainer = styled.div`
  background: ${props => props.theme.color.white};
  display: flex;
  margin: 0 10px;
  width: 25%;
  min-width:320px;
`;
const PaymentCardContainer = styled(CardContainer)`
  width: 50%;
  min-width: 370px;
  margin-left: 20px;
  @media (max-width: 720px) {
    width: 96%;
  }
`;
const FormContainer = styled.div`
  margin-top: 32px;
  border-radius: 8px;
  background-color: ${ThemeProps.color.softYellow};
`;